import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=5050b6c1&scoped=true&"
import script from "./Assignments.vue?vue&type=script&lang=js&"
export * from "./Assignments.vue?vue&type=script&lang=js&"
import style0 from "./Assignments.vue?vue&type=style&index=0&id=5050b6c1&scoped=true&lang=css&"
import style1 from "./Assignments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050b6c1",
  null
  
)

export default component.exports